
import { Mixins, Component, Ref, Prop, Watch } from "vue-property-decorator";
import loading from "@/mixins/loading";
import { Form } from "element-ui/types";
import {
  getWeigherTwelveHourGuideDetail,
  updateWeigherTwelveHourGuide
} from "@/api/twoHour";

@Component({ components: {} })
export default class WeightEditDialog extends Mixins(loading) {
  @Ref("validateForm") validateForm: Form;
  @Prop([Boolean]) private dialogVisible!: boolean;
  @Prop([Number]) private id!: number;

  formData = {
    time: "",
    name: "",
    mustDo: "",
    mustDoDesc: "",
    taboo: "",
    tabooDesc: "",
    fatLossCore: "",
    fatLossPrinciple: "",
  };

  rules = {
    mustDo: [
      { required: true, message: "请输入减脂必做", trigger: "blur" },
    ],
    mustDoDesc: [
      { required: true, message: "请输入必做说明", trigger: "blur" },
    ],
    taboo: [
      { required: true, message: "请输入发胖雷区", trigger: "blur" },
    ],
    tabooDesc: [
      { required: true, message: "请输入雷区说明", trigger: "blur" },
    ],
    fatLossCore: [
      { required: true, message: "请输入减脂核心", trigger: "blur" },
    ],
    fatLossPrinciple: [
      { required: true, message: "请输入减脂原理", trigger: "blur" },
    ],
  };

  dialogClose() {
    this.validateForm?.resetFields();
    this.$emit('closeEditDialog');
  }

  saveData() {
    this.validateForm?.validate().then((valid) => {
      if (valid) {
        const params = {
          id: this.id,
          mustDo: this.formData.mustDo,
          mustDoDesc: this.formData.mustDoDesc,
          taboo: this.formData.taboo,
          tabooDesc: this.formData.tabooDesc,
          fatLossCore: this.formData.fatLossCore,
          fatLossPrinciple: this.formData.fatLossPrinciple,
        };
        this.showLoading();
        updateWeigherTwelveHourGuide(params).then(() => {
          this.$message.success("保存成功");
          this.$emit('editDialogConfirm');
        }).finally(() => {
          this.hideLoading();
        });
      }
    });
  }

  @Watch("dialogVisible", { immediate: true })
  getData() {
    if (this.dialogVisible !== true) return;
    getWeigherTwelveHourGuideDetail({ id: this.id }).then((res) => {
      const data = res.data || {};
      this.formData = {
        ...data,
        time: (data.startTime || "").slice(0, 5) + " - " + (data.endTime || "").slice(0, 5)
      };
    });
  }
}
